import { RootState } from 'store/ducks';
import TicketServices from './ticket.service';
import { IOrders } from 'models/Order';
import toast from 'components/Toast/dispatch';

export default class CreateProtocolServices {
    createProtocol = async (order: IOrders, user: RootState['user']) => {
        const _ticketService = new TicketServices();

        const item: any = {
            protocolNumber: 0,
            legalPerson: order.company?.personType === "Juridica" ? 1 : 2,
            communicationChannel: "PORTAL_CC",
            protocolCategory: "LOGISTICA",
            ticketReason: "PREVISÃO DE ENTREGA",
            contactName: user?.fullName,
            contactMailAddress: user?.email,
            contactPhoneNumber: user?.phoneNumber,
            order: order,
            description: `Solicitação do tracking do pedido: ${order.protheusOrderSale}.`,
            tags: ["TRACKING DO PEDIDO", "SOLICITAÇÃO", "2A_VIA", "CUSTOMER_CARE"],
            linkTicketIdentifier: "",
            customerId: order.customerId,
            customerName: user?.fullName,
            attendenceType: "SELF_SERVICE"
        };

        const response = await _ticketService.create(item);

        if (response.status === 200) {
            const { data } = response.data;
            toast.success(`O protocolo ${data.protocolNumber} foi registrado com sucesso`);
        } else {
            toast.error('Ocorreu um erro durante a requisição');
        }
    };
}